<template>
    <footer>
        <div class="footerlogos">
            <div class="footerlogo-left-alt">
                <a href="https://www.chi-athenaeum.org/" target="_blank"
                    ><img src="/images/TCA-new.png" class="tca-logo"
                /></a>
                <div class="footercontact-alt">
                    The Chicago Athenaeum<BR /> 601 South Prospect Street,
                    Galena, Illinois 61036, USA<BR /> <strong>Tel:</strong> +1
                    815 777 4444 | <strong>Fax:</strong> +1 815 777 2471
                    <BR />
                    <strong>E-mail:</strong> curatorial@chicagoathenaeum.org
                </div>
                <a href="https://www.europeanarch.eu/" target="_blank"
                    ><img src="/images/ECADUS-LOGOTYPE.png" class="ecadus-logo"
                /></a>
                <div class="footercontact-alt">
                    The European Centre for Architecture<BR /> Art Design and
                    Urban Studies<BR /> 28 Butlers Court Sir John Rogerson's
                    Quay, Dublin 2, Ireland<BR /> <strong>Tel:</strong> 00 353
                    (0) 1 670 8781,
                    <strong>Email:</strong> fachanan@europeanarch.eu
                </div>
            </div>
            <div class="footerlogo-right">
                <slot></slot>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
    name: "Footer",
    methods: {},
    mounted() {},
    computed: {},
};
</script>
